import React, { Component } from 'react';
import {
  ActivityIndicator, List, Modal, Toast,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from './styles.module.less';

import pass from './images/pass.png';
import nopass from './images/nopass.png';
import reviewing from './images/reviewing.png';

import {
  getChannelApplyForm,
  saveChannelApplyForm,
  auditApplyForm,
  getChannelApplyFormByUserId,
  getMaxTimes,
} from '../../service/chat-service';

import tools from '../../utils/tools';

const { Item } = List;
const { alert } = Modal;

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

class ChannelList extends Component {
  constructor(props) {
    super(props);

    const channelType = tools.getQueryString('channelType');

    this.state = {
      radioChannelList: [],
      checkBoxChannelList: [],
      pageSize: 10000,
      pageNum: 1,
      // answers: [],
      answersItemArrs: [],
      animating: false,
      // score: 0,
      scoreAll: [],
      singleAnswers: [],
      hint: {},
      // newMaxTimes: '',
      // newType: '',
      channelUserId: undefined,
      channelUserIdFlag: false,
      pchannelType: '',
      pmaxTimes: '',
      inputDisabled: channelType === '3' || channelType === '4', // 状态是3时查看禁用单选，复选框
      againSubmit: true,
    };
    document.title = tools.getQueryString('type') === '1' ? '填写申请表' : '在线考试';

    this.handleAnswer = this.handleAnswer.bind(this);
  }

  componentDidMount() {
    this.getUrlSearch();
  }

  // 获取url参数
  getUrlSearch = () => {
    const channelUserId = tools.getQueryString('channelUserId');
    if (channelUserId) {
      this.setState({ channelUserId, channelUserIdFlag: true }, () => {
        this.loadData();
      });
    } else {
      this.loadData();
      this.getMaxTimes();
    }
  }

  // 获取提交剩余次数
  getMaxTimes = async () => {
    const settingId = tools.getQueryString('settingId');
    try {
      const { data } = await getMaxTimes(settingId);
      this.setState({ pmaxTimes: data });
    } catch (e) {
      // console.log(e);
    }
  }

  // 递归整理单选答案
  getNamesByType = (target, init = []) => {
    target.forEach((item) => {
      if (item.isSelect === 1) init.push(item);
      if (item.channelAnswersInfoList) this.getNamesByType(item.channelAnswersInfoList, init);
    });
    return init;
  }

  loadData = async () => {
    const {
      channelUserId, channelUserIdFlag, pchannelType, againSubmit, pageSize, pageNum,
    } = this.state;
    const channelType = pchannelType.toString() || tools.getQueryString('channelType');

    const type = tools.getQueryString('type');
    const server = channelUserIdFlag || ((channelType === '3' || channelType === '4') && againSubmit)
      ? getChannelApplyFormByUserId
      : getChannelApplyForm;
    this.setState({ animating: true });

    try {
      const { data } = await server(
        pageSize,
        pageNum,
        type,
        (channelType === '3' || channelType === '4') && !channelUserIdFlag
          ? localStorage.getItem('userId')
          : channelUserId,
      );

      const radioChannelData = data.pageList.filter((item) => item.questionsType === '1');
      const checkBoxChannelData = data.pageList.filter((item) => item.questionsType === '2');
      const singleDataFromApi = this.getNamesByType(radioChannelData);
      const multipleDataFromApi = this.getNamesByType(checkBoxChannelData);

      this.setState({
        singleAnswers: this.handleCheckBoxChannelList(singleDataFromApi),
        scoreAll: singleDataFromApi,
        answersItemArrs: multipleDataFromApi,
        radioChannelList: radioChannelData,
        checkBoxChannelList: checkBoxChannelData,
        hint: data.hint,
        animating: false,
        // reviewMethod: data.reviewMethod,
      });
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  // 整理多选数据
  handleCheckBoxChannelList = (answersItemArrs) => {
    const listArr = [];
    answersItemArrs.forEach((item) => {
      for (let i = 0; i < listArr.length; i += 1) {
        // 对比相同的字段
        if (listArr[i].questionsId === item.questionsId) {
          listArr[i].answersId.push(item.id);
          return;
        }
      }
      // 第一次对比没有参照，放入参照
      listArr.push({
        questionsId: item.questionsId,
        answersId: [item.id],
      });
    });
    return listArr;
  }

  // 计算分数
  handleAllScore = () => {
    const { scoreAll, answersItemArrs } = this.state;
    const scoreForm = [...scoreAll, ...answersItemArrs].map((item) => item.score);
    return scoreForm.reduce((total, next) => total + next, 0);
  }

  // 单选多选设置
  handleAnswer = async (item, type) => {
    const { scoreAll, singleAnswers, answersItemArrs } = this.state;
    const answersItem = {};
    const answersItemArr = [];
    answersItem.questionsId = item.questionsId;
    if (type === 'radio') {
      answersItemArr.push(item.id);
      answersItem.answersId = answersItemArr;
      // 整理单选分数
      if (scoreAll.some((items) => items.questionsId === item.questionsId)) {
        const index = scoreAll.findIndex((items) => items.questionsId === item.questionsId);
        scoreAll.splice(index, 1, item);
      } else {
        scoreAll.push(item);
      }

      // 整理答案单选
      if (singleAnswers.some((items) => items.questionsId === item.questionsId)) {
        const index = singleAnswers.findIndex((items) => items.questionsId === item.questionsId);
        singleAnswers.splice(index, 1, answersItem);
      } else {
        singleAnswers.push(answersItem);
      }
      // setSingleAnswers(answersItem, item, answersItemArr)
    } else if (answersItemArrs.some((items) => items.id === item.id)) {
      const multipleIndex = answersItemArrs.findIndex((items) => items.id === item.id);
      answersItemArrs.splice(multipleIndex, 1);
    } else {
      answersItemArrs.push(item);
    }
  }

  // 渲染答案列表

  renderAnswerList = (type, channelAnswersInfoList, index) => {
    const {
      pchannelType, pmaxTimes, channelUserIdFlag, inputDisabled, againSubmit,
    } = this.state;
    const channelType = pchannelType.toString() || tools.getQueryString('channelType');
    const character = [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'X',
      'Y',
      'Z',
    ];
    channelAnswersInfoList.map((item, itemIndex) => character.forEach((answer, index1) => {
      const item1 = item;
      if (itemIndex === index1) {
        item1.answerIndex = answer;
      }
    }));
    return channelAnswersInfoList.map((item) => (
      /**
         * @param channelType 状态 4:不通过 3：审阅中
         * @param pmaxTimes 剩余次数
         * @param channelUserIdFlag 是否是渠道 是：渠道 否：员工
         * return
         * */
      <Item
        key={item.id}
        wrap
        extra={
            (channelType === '3' && pmaxTimes > 0 && !channelUserIdFlag) || channelType === '2' || !againSubmit
              ? ''
              : `${item.score} 分`
          }
      >
        <input
          className={styles.orange}
          type={type}
          disabled={channelUserIdFlag || channelType === '1' || pmaxTimes <= 0 || inputDisabled}
          name={item.questionsId}
            // id={`check${item.id}`}
          defaultChecked={item.isSelect === 1}
          value={item.isSelect}
          onChange={this.handleAnswer.bind(this, item, type, index)}
        />
        {item.answerIndex}
        、
        {item.answers}
      </Item>
    ));
  }

  // 验证所有题必填
  handleFormRequired = (oringeData, data) => {
    if (oringeData.length !== data.length) {
      return true;
    }
    return false;
  }

  submit = async () => {
    const { history } = this.props;
    const {
      singleAnswers, answersItemArrs, pmaxTimes, radioChannelList, checkBoxChannelList,
    } = this.state;
    const type = tools.getQueryString('type');
    const settingId = tools.getQueryString('settingId');
    const multipleAnswers = this.handleCheckBoxChannelList(answersItemArrs);
    const oringeData = [...radioChannelList, ...checkBoxChannelList];

    if (this.handleFormRequired(oringeData, [...singleAnswers, ...multipleAnswers])) {
      Toast.show('有未回答的问题，请检查后提交！');
      return;
    }

    if (pmaxTimes === 0) {
      Toast.show('您的答题次数已用尽！');
      return;
    }

    alert('确定提交吗？', `您还有【${pmaxTimes}】次提交机会`, [
      {
        text: '再看看',
        onPress: () => {
        // console.log('cancel')
        },
      },
      {
        text: '确定',
        onPress: async () => {
          try {
            await saveChannelApplyForm(
              [...singleAnswers, ...multipleAnswers],
              type,
              settingId,
              this.handleAllScore(),
            );
            history.push('/channelLevel?channelUserId=undefined');
            Toast.show('提交成功！');
          } catch (e) {
            Toast.show('提交失败！');
          }
        },
      },
    ]);
  }

  // 渲染单选问题
  renderSingleChannelList = () => {
    const { radioChannelList } = this.state;
    return radioChannelList.map((item, index) => (
      <List key={item.id}>
        <Item wrap>
          {index + 1}
          .
          {item.questions}
        </Item>
        {this.renderAnswerList('radio', item.channelAnswersInfoList, index)}
      </List>
    ));
  }

  // 渲染多选问题
  renderMultipleChannelList = () => {
    const { checkBoxChannelList } = this.state;
    return checkBoxChannelList.map((item, index) => (
      <List key={item.id}>
        <Item wrap>
          {index + 1}
          .
          {item.questions}
        </Item>
        {this.renderAnswerList('checkbox', item.channelAnswersInfoList, index)}
      </List>
    ));
  }

  auditSubmit = async (auditType) => {
    const { history } = this.props;
    const channelUserId = tools.getQueryString('channelUserId');
    const type = tools.getQueryString('type');
    try {
      await auditApplyForm(channelUserId, type, auditType);

      history.push(`/channelLevel?channelUserId=${channelUserId}`);
      Toast.show('审核成功！');
    } catch (e) {
      Toast.show('审核失败！');
    }
  }

  /**
   * 待审核状态（3），未通过（4），并且判断是否还有提交次数。。。。重新提交
   */

  againSubmit = () => {
    const { pmaxTimes } = this.state;
    const channelType = tools.getQueryString('channelType');

    const flag = Number(pmaxTimes) > 0;
    const title = flag ? '确定要重新提交吗？' : '抱歉，您不能再填写了';
    const content = flag ? '您上次提交的答卷还在审核评分中' : '您的提交机会次数用光了，实在抱歉';
    const actions = [
      {
        text: '再看看',
        onPress: () => {
        // console.log('cancel')
        },
      },
      {
        text: '确定',
        onPress: () => {
          this.setState({ inputDisabled: !flag, againSubmit: false }, () => {
            this.loadData();
          });
        },
      },
    ];
    if (!flag) actions.splice(0, 1);
    if (channelType === '3') {
      alert(title, content, [...actions]);
    } else {
      this.setState({ inputDisabled: !flag, againSubmit: false }, () => {
        this.loadData();
      });
    }
  }

  /**
   * 在线考试状态展示
   */
  handleTestStatus = () => {
    const { pchannelType } = this.state;
    const channelType = pchannelType || tools.getQueryString('channelType');
    if (Number(channelType) === 3) {
      return reviewing;
    } if (Number(channelType) === 4) {
      return nopass;
    } if (Number(channelType) === 1) {
      return pass;
    }
    return '';
  }

  /**
   * @param channelType 状态 4:不通过 3：审阅中
   * @param pmaxTimes 剩余次数
   * @param channelUserIdFlag 是否是渠道 是：渠道 否：员工
   * @return 以下提示语分数提交按钮展示均用以上条件判断 状态3或4或2且有提交次数且是渠道 (不展示提示语分数) 反之显示
   * */
  render() {
    const {
      pchannelType,
      pmaxTimes,
      channelUserIdFlag,
      inputDisabled,
      againSubmit,
      hint,
      radioChannelList,
      checkBoxChannelList,
      animating,
    } = this.state;
    const channelType = pchannelType.toString() || tools.getQueryString('channelType');
    // const channelUserId = tools.getQueryString('channelUserId')
    if (!channelType) return null;

    return (
      <div className={styles.box} style={{ paddingBottom: '60px' }}>
        <div
          className={styles.scoreBox}
          style={{
            display: (channelType === '2' && !channelUserIdFlag) || !againSubmit || !hint ? 'none' : 'block',
          }}
        >
          <div className={styles.score}>
            <div>
              问卷得分：
              <span className={styles.scoreDet}>
                {hint && JSON.stringify(hint) !== '{}' ? hint.source : ''}
                分
              </span>
              <div className={styles.scorePrompt}>
                提示语：【
                {hint && JSON.stringify(hint) !== '{}'
                  ? hint.type === '1' || !channelUserIdFlag
                    ? hint.channelHint
                    : hint.staffHint
                  : ''}
                】
              </div>
            </div>
            <img src={this.handleTestStatus()} alt="" />
          </div>
        </div>
        <div className={styles.line}>{radioChannelList.length > 0 ? '单选问题' : ''}</div>
        {this.renderSingleChannelList()}
        <div className={styles.line}>{checkBoxChannelList.length > 0 ? '多选问题' : ''}</div>
        {this.renderMultipleChannelList()}

        {!channelUserIdFlag ? (
          <div>
            {channelType === '2' || (!inputDisabled && channelType !== '1') ? (
              <button className={styles.bottomButton} type="submit" onClick={this.submit}>
                提交
              </button>
            ) : (channelType === '3' || channelType === '4') && pmaxTimes > 0 ? (
              <button className={styles.bottomButton} type="button" onClick={this.againSubmit}>
                重新填写
              </button>
            ) : null}
          </div>
        ) : channelType === '3' ? (
          <div className={styles.auditBtnBox}>
            <button className={styles.auditBtn} type="button" onClick={this.auditSubmit.bind(this, 4)}>
              不通过
            </button>
            <button className={styles.auditBtn} type="button" onClick={this.auditSubmit.bind(this, 1)}>
              通过
            </button>
          </div>
        ) : null}

        <ActivityIndicator toast text="正在加载" animating={animating} />
      </div>
    );
  }
}

ChannelList.propTypes = propTypes;

export default ChannelList;
